import { render, staticRenderFns } from "./DSProfileIcon.vue?vue&type=template&id=2b68b4ba&scoped=true&"
import script from "./DSProfileIcon.vue?vue&type=script&lang=js&"
export * from "./DSProfileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b68b4ba",
  null
  
)

export default component.exports